import React, { useEffect, useState, useCallback } from "react";
import { getRequestInAssets as getRequestOnEnterprise } from "services/axiosAssetsBaseClient";
import { postRequest as postRequestEnterprise } from "services/axiosBaseClient"
import TableAndSearch from "../common/TableAndSearch";
import { useHistory, Link } from "react-router-dom";
import LocalStorageService from "services/tokenlocalstorage.service";
import QRCodeView from '../../components/QRcode/QRCode';
import ConfirmationDialog from "../common/ConfirmDialog";
import notificationService from "services/notification.service";

var tableSearchKey;
var tempSearch;
export default function VehicleList(props) {
  const { headerFilterParms, headerFilter } = props;

  const history = useHistory();
  const [specialCharacters, setspecialCharacters] = useState(false);
  const [vehicleHeaderFilterData, setVehicleHeaderFilterData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [tempSwap, setTempSwap] = useState([]);

  const VehicleHeaderFilterHandle = (searchString) => {
    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(LocalStorageService.get("queryHeader"));

    var query =
      (headerFilterObj?.enterprise
        ? "enterprise=" + headerFilterObj.enterprise
        : "") +
      (headerFilterObj?.stateId ? "&stateId=" + headerFilterObj?.stateId : "") +
      (headerFilterObj?.cityId ? "&cityId=" + headerFilterObj?.cityId : "") +
      (headerFilterObj?.zoneId ? "&zoneId=" + headerFilterObj?.zoneId : "") +
      (typeof searchString === "object" ||
        typeof searchString === "undefined" ||
        (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&regNo=" + encodeURIComponent(searchString));

    query = query ? "?" + query : "";
    try {
      getRequestOnEnterprise("getAllVehicles" + query)
        .then((resp) => {
          if (resp?.data && resp.data.length > 0) {
            // let updatedResult = getMakeName(resp?.data, "false");
            setVehicleHeaderFilterData(resp?.data);
            props.assetCount(() => resp?.data?.length);
            // batteryListDataSortHandle(resp?.data?.battery);
            setTotalCount(resp?.data.length);
          } else {
            setVehicleHeaderFilterData([]);
            props.assetCount(0);
          }
        })
        .catch((e) => {
          setVehicleHeaderFilterData([]);
          props.assetCount(0);
          console.log(e, "ERROR");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const batteryListDataSortHandle = (data) => {
    var newBattery = [];
    var oldBattery = [];
    data.map((battery) => {
      if (battery.warrantyStartDate == null) {
        oldBattery.push(battery);
      } else {
        newBattery.push(battery);
      }
    });
    startSortingHandle(newBattery, oldBattery);
  };
  const startSortingHandle = (newBattery, oldBattery) => {
    const sortedData = newBattery.sort(function (a, b) {
      var dateA = new Date(a.warrantyStartDate);
      var dateB = new Date(b.warrantyStartDate);
      return dateB - dateA;
    });
    mergingOldNewBattery(sortedData, oldBattery);
  };

  const mergingOldNewBattery = (sortedData, oldBattery) => {
    for (let i of oldBattery) {
      sortedData.push(i);
    }
    setVehicleHeaderFilterData(sortedData);
  };


  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      VehicleHeaderFilterHandle();
    } else {
      VehicleHeaderFilterHandle(tempSearch.trim());
    }
  }, []);

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    setVehicleHeaderFilterData([]);
    VehicleHeaderFilterHandle(tempSearch.trim());
  }, [headerFilter]);

  const view = (id, enterpriseName) => {
    // + `/${enterpriseName}`
    history.push("/Assets/viewVehicle/" + id + "/view");
  };

  const update = (id, enterpriseName) => {
    history.push("/Assets/updateVehicle/" + id);
  };

  const unassignDriver = useCallback(async (data) => {
    try {
      postRequestEnterprise("bss/vehicle/removeDriver", JSON.stringify({ vehicleNumber:data.vehicleNumber }))
        .then((res) => {
          if (res.data != null) {
            vehicleHeaderFilterData.filter((vehicle) => {
              if (vehicle.id == data.id) {
                vehicle.driverName = null;
                vehicle.driverNumber = null;
              }
            });
            setTempSwap(res.data);
            notificationService.showNonBlacklisted(res?.config?.url, res.message);
          }
        })
        .catch((error) => {
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.response?.data?.message
          );
          return error;
        });
    } catch (err) {
      console.log(err);
      notificationService.showNonBlacklistedError(
        err?.config?.url,
        err?.response?.data?.message
      );
    }
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "Registration Number",
        accessor: "regNo",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.regNo ? row.row?.original?.regNo : "NA"}
            </div>
          );
        },
      },
      {
        Header: "Vehicle Number",
        accessor: "vehicleNumber",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.vehicleNumber
                ? row.row?.original?.vehicleNumber
                : "NA"}
            </div>
          );
        },
      },
      {
        Header: "Driver Name",
        accessor: "driverName",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.driverName
                ? row.row?.original?.driverName
                : "NA"}
            </div>
          );
        },
      },
      {
        Header: "Driver Number",
        accessor: "driverNumber",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.driverNumber
                ? row.row?.original?.driverNumber
                : "NA"}
            </div>
          );
        },
      },
      {
        Header: "Site Name",
        accessor: "siteName",
        Cell: (row) => {
          return (
            <div>
              {row.row?.original?.shortSiteName
                ? row.row?.original?.shortSiteName
                : row.row?.original?.siteName
                  ? row.row?.original?.siteName
                  : "NA"}
            </div>
          );
        },
      },
      {
        Header: "Type",
        accessor: "vehicleType",
        Cell: (row) => {
          return (
            <div>
              {(row.row?.original?.vehicleType && row.row?.original?.vehicleType != -1)
                ? row.row?.original?.vehicleType
                : "NA"}
            </div>
          );
        },
      },
      {
        Header: "manufacturer",
        accessor: "makeName",
        Cell: (row) => {
          return <div>{row.value ? row.value : "NA"}</div>;
        },
      },
      {
        Header: "Model",
        accessor: "modelName",
        Cell: (row) => {
          return <div>{row.value ? row.value : "NA"}</div>;
        },
      },
      {
        Header: "QR Code",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <QRCodeView
                value={row.row.original.regNo.toString()}
                visibility={false}
              />
            </>
          )
        }
      },
      {
        Header: "Action",
        accessor: "id",
        disableSortBy: true,
        Cell: (cell) => {
          return (
            <>
              <div>
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px", cursor: "pointer" }}
                  onClick={() => view(cell.value, cell.row.original.enterprise)}
                ></img>
                <img
                  src={require("assets/pencil.png").default}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    update(cell.value, cell.row.original.enterprise)
                  }
                ></img>
                {
                  cell.row?.original?.driverName && cell.row?.original?.driverNumber &&
                  <ConfirmationDialog
                    data={cell.row.original}
                    handleStatus={(data) => { unassignDriver(data) }}
                    assets={"Vehicle"}
                    name={cell.row.original.vehicleNumber}
                  />
                }

              </div>
            </>
          );
        },
      },
    ],
    [vehicleHeaderFilterData, tempSwap]
  );
  return (
    <div>
      <TableAndSearch
        totalCount={totalCount}
        searchOpts={{
          onSearch: VehicleHeaderFilterHandle,
          placeholder: "Search By Registration Number",
        }}
        specialCharacters={specialCharacters}
        columns={columns}
        data={vehicleHeaderFilterData}
        tigger={props?.tigger}
        tabTemp={props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={props.headerFilterParms}
      />
    </div>
  );
}

VehicleList.inStorybook = true;
